export default "__VITE_ASSET__CI$XDQyE__"